module.exports = __webpack_public_path__ + "img/alert-triangle.cede219.svg";